import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className={`ri-heart-pulse-line text-2xl ${isScrolled || !isHome ? 'text-primary-500' : 'text-background-50'}`}></i>
            </div>
            <span className={`font-heading text-lg font-semibold whitespace-nowrap ${isScrolled || !isHome ? 'text-foreground-900' : 'text-background-50'}`}>
              {t('site.name')}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                location.pathname === '/'
                  ? (isScrolled || !isHome ? 'text-primary-500' : 'text-background-50 font-semibold')
                  : (isScrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/80 hover:text-background-50')
              }`}
            >
              {t('nav.home')}
            </Link>
            <Link
              to="/category/self-identity"
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                location.pathname.startsWith('/category')
                  ? (isScrolled || !isHome ? 'text-primary-500' : 'text-background-50 font-semibold')
                  : (isScrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/80 hover:text-background-50')
              }`}
            >
              {t('nav.categories')}
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                location.pathname === '/about'
                  ? (isScrolled || !isHome ? 'text-primary-500' : 'text-background-50 font-semibold')
                  : (isScrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/80 hover:text-background-50')
              }`}
            >
              {t('nav.about')}
            </Link>
          </div>

          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer rounded-lg ${
              isScrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer py-2">
              {t('nav.home')}
            </Link>
            <Link to="/category/self-identity" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer py-2">
              {t('nav.categories')}
            </Link>
            <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer py-2">
              {t('nav.about')}
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}